import { useCallback } from 'react';
import type { FormField } from '../contexts';
import { useWidgetDispatch } from '../contexts';
import { useFormReset } from './useFormReset';

export function usePageRedirect(
  submitRedirectURL: string,
  fields: FormField[]
) {
  const dispatch = useWidgetDispatch();
  const resetForm = useFormReset(fields);

  return useCallback(() => {
    dispatch({
      type: 'toggleSubmitted',
      submitted: true
    });

    resetForm();

    const validURL = !/^(http(s?)|tel|mailto):/.test(submitRedirectURL)
      ? `https://${submitRedirectURL}`
      : submitRedirectURL;

    window.open(validURL, '_top');
  }, [dispatch, submitRedirectURL]);
}
